<script>
    import {page, url} from '@sveltech/routify'
    import {services} from '../database/services'
    import {fade} from 'svelte/transition';
    import {watchResize} from "svelte-watch-resize";
    import cityLocalizer from "../util/cityLocalizer";
    import {onDestroy, onMount, setContext} from "svelte";
    import {writable} from "svelte/store";
    import SessionData from "../store/sessionData";
    import ShareButtons from "../components/ShareButtons.svelte";
    import cities from "../database/cities";
    import {saveScrollPosition, setCurrentPage, handleBackNavigation} from "../components/navigation/ScrollManager";

    let mydrLoaded = false;
    let mobileMenuVisible = false;
    let footerVisible = false;
    let footerClass = 'hidden';
    let currentCity = writable('');
    let session = new SessionData();

    setTimeout(() => {
        footerVisible = true;
    }, 2000);

    $: footerClass = footerVisible ? '' : 'hidden';

    setContext('session', session);

    function openMyDr() {
        if (!session.isMydrLoaded()) {
            const mydrScript = document.getElementsByTagName('script')[0];
            const js = document.createElement('script');
            js.src = "https://mydr.pl/static/mydr-pp.min.js";
            mydrScript.parentNode.insertBefore(js, mydrScript);

            js.onload = () => {
                const PatientsPlugin = new window.PatientsPlugin;
                PatientsPlugin.init({
                    app: 'https://mydr.pl/patients_plugin',
                    plugin: 'https://mydr.pl/static',
                });
                document.getElementsByClassName('btn-mydr-pp')[0].click();
            };
            session.setMydrLoaded();
        }
    }

    // let employees = [];

    // for (let specialization in $people) {
    //     for (let employeeKey in $people[specialization]) {
    //         let employee = $people[specialization][employeeKey];
    //
    //         employees.push({
    //             "@type": "Person",
    //             "name": employee.firstName + ' ' + employee.lastName,
    //             "givenName": employee.firstName,
    //             "familyName": employee.lastName,
    //             "jobTitle": employee.profession,
    //             "description": employee.profession,
    //             "telephone": '504 64 64 66',
    //             "sameAs": window.location.origin + '/zespol/' + employee.slug + '/',
    //             "image": window.location.origin + '/images/team/' + employee.avatar
    //         })
    //     }
    // }

    function generateBusinessJsonLd(city) {
        let isCityDefined = city !== '' && city !== null && typeof city !== 'undefined';
        let cityData = $cities[isCityDefined ? city : 'torun'];

        let data = {
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "Centrum Psychiatrii i Psychoterapii COLLIGO",
            "parentOrganization": {
                "@id": "https://colligo.pl/#organization"
            },
            "logo": "https://colligo.pl/images/colligo-logo-poprawne.png",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": cityData['address'],
                "addressLocality": cityData['name'],
                "addressRegion": "kujawsko - pomorskie",
                "addressCountry": "PL",
                "postalCode": cityData['postalCode'],
            },
            "image": "https://colligo.pl/images/colligo-logo-poprawne.png",
            "email": cityData['email'],
            "telePhone": cityData['phone'],
            "url": isCityDefined ? "www.colligo.pl/" + city : "www.colligo.pl",
            "paymentAccepted": ["cash", "credit card"],
            "openingHours": "Mo,Tu,We,Th,Fr 08:00-21:00",
            "openingHoursSpecification": [{
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday"
                ],
                "opens": "08:00",
                "closes": "21:00"
            }],
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": cityData['latitude'],
                "longitude": cityData['longitude']
            },
            "priceRange": "$$",
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "5",
                "reviewCount": "9"
            },
            // "employee": employees,
            "review": [
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "ANNA WERNER"
                    },
                    "datePublished": "2020-10-21",
                    "description": "Profesjonalna obsługa, miła atmosfera, my jesteśmy zadowoleni. Polecam",
                    "name": "Profesjonalna obsługa, miła atmosfera, my jesteśmy zadowoleni. Polecam",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Darek Gemba"
                    },
                    "datePublished": "2020-10-25",
                    "description": "Darek Gemba",
                    "name": "Darek Gemba",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Arpina Pawłowska"
                    },
                    "datePublished": "2020-10-29",
                    "description": "Arpina Pawłowska",
                    "name": "Arpina Pawłowska",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Marek Majewski"
                    },
                    "datePublished": "2020-11-15",
                    "description": "Marek Majewski",
                    "name": "Marek Majewski",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Magdalena Roguszczak"
                    },
                    "datePublished": "2020-12-15",
                    "description": "Magdalena Roguszczak",
                    "name": "Magdalena Roguszczak",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Wiktor Brzeziński"
                    },
                    "datePublished": "2021-01-15",
                    "description": "Wiktor Brzeziński",
                    "name": "Wiktor Brzeziński",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Maria Baranowska"
                    },
                    "datePublished": "2021-01-22",
                    "description": "Świetne miejsce tworzone przez ludzi z pasją do pomagania. Niesamowita atmosfera wsparcia i zrozumienia w kazdym problemie. Dr Janiszewska to lekarz z powołania, zawsze można liczyć na jej zrozumienie i pomoc, serdecznie polecam :)",
                    "name": "Maria Baranowska",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Marta Szmejter"
                    },
                    "datePublished": "2021-07-16",
                    "description": "Marta Szmejter",
                    "name": "Marta Szmejter",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                },
                {
                    "@type": "Review",
                    "author": {
                        "@type": "Person",
                        "name": "Parzydełkowiec"
                    },
                    "datePublished": "2021-08-30",
                    "description": "Miejsce bardzo przyjemne i bardzo mili psychologowie. Polecam ♥",
                    "name": "Parzydełkowiec",
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": "5",
                        "ratingValue": "5",
                        "worstRating": "1"
                    }
                }
            ]
        }

        if (!isCityDefined) {
            data['location'] = [
                {
                    "@type": "MedicalBusiness",
                    "name": "Centrum Psychiatrii i Psychoterapii COLLIGO w Toruniu",
                    "parentOrganization": {
                        "@id": "https://colligo.pl/#organization"
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": $cities['torun']['address'],
                        "addressLocality": $cities['torun']['name'],
                        "addressRegion": "kujawsko - pomorskie",
                        "addressCountry": "PL",
                        "postalCode": $cities['torun']['postalCode'],
                    },
                    "priceRange": "$$",
                    "telePhone": $cities['torun']['phone'],
                    "image": "https://colligo.pl/images/colligo-logo-poprawne.png",
                },
                {
                    "@type": "MedicalBusiness",
                    "name": "Centrum Psychiatrii i Psychoterapii COLLIGO w Bydgoszczy",
                    "parentOrganization": {
                        "@id": "https://colligo.pl/#organization"
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": $cities['bydgoszcz']['address'],
                        "addressLocality": $cities['bydgoszcz']['name'],
                        "addressRegion": "kujawsko - pomorskie",
                        "addressCountry": "PL",
                        "postalCode": $cities['bydgoszcz']['postalCode'],
                    },
                    "priceRange": "$$",
                    "telePhone": $cities['bydgoszcz']['phone'],
                    "image": "https://colligo.pl/images/colligo-logo-poprawne.png",
                }
            ]
        }
        return data;
    }

    let jsonld;

    let jsonld3 = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "url": "https://colligo.pl/",
        "sameAs": ["https://www.facebook.com/Colligo-2036303623333529", "https://www.linkedin.com/company/centrum-psychiatrii-i-psychoterapii-colligo", "https://www.youtube.com/channel/UCRojzOJYg2Yp9PLDM6o7wmA", "https://pl.pinterest.com/colligotorun/"],
        "@id": "https://colligo.pl/#organization",
        "name": "Centrum Psychiatrii i Psychoterapii COLLIGO",
        "logo": "https://colligo.pl/images/colligo-logo-poprawne.png",
        "departments": []
    };

    function setDepartments(list) {
        jsonld3.departments = list;
        return jsonld3;
    }

    $: jsonld = JSON.stringify(setDepartments(generateBusinessJsonLd($currentCity)));

    let jsonld2 = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": "https://colligo.pl/#website",
        "url": "https://colligo.pl/",
        "name": "Psychiatria dzieci i m\u0142odzie\u017cy, psychiatria os\u00f3b doros\u0142ych, psychoterapia, psychologia | COLLIGO",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://colligo.pl/?s={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };

    jsonld2 = JSON.stringify(jsonld2);
    // jsonld3 = JSON.stringify(jsonld3);

    function toggleMobileMenuVisibility() {
        mobileMenuVisible = !mobileMenuVisible;
    }

    function hideMobileMenu() {
        if (window.innerWidth <= 996) {
            mobileMenuVisible = false;
        }
    }

    if (window.innerWidth > 996) {
        mobileMenuVisible = true;
    }

    function handleResize(node) {
        if (window.innerWidth <= 996) {
            mobileMenuVisible = false;
        } else {
            mobileMenuVisible = true;
        }
    }

    let unsubscribe;

    // function navigate(page) {
    //     saveScrollPosition();
    //     setCurrentPage(page);
    // }

    onMount(() => {
        // Update the current URL whenever the route changes
        const updateUrl = () => {
            if (window.location.href.indexOf('/bydgoszcz') > -1) {
                currentCity.set('bydgoszcz');
            } else if (window.location.href.indexOf('/torun') > -1) {
                currentCity.set('torun');
            } else {
                currentCity.set(null);
            }
        };
        // Add a listener for the 'popstate' event (back/forward navigation)
        window.addEventListener('popstate', updateUrl);
        window.addEventListener('pushstate', updateUrl);

        // Clean up the listener when the component is destroyed
        updateUrl();

        jsonld = $currentCity;

        handleBackNavigation();

        unsubscribe = page.subscribe($page => {
            saveScrollPosition();
            setCurrentPage($page.path);
        });

        return () => {
            window.removeEventListener('popstate', updateUrl);
            window.removeEventListener('pushstate', updateUrl);
            unsubscribe();
        };
    });
</script>
<svelte:head>
    {@html `<script type="application/ld+json">${jsonld}</script>`}
    {@html `<script type="application/ld+json">${jsonld2}</script>`}
    {@html `<!--<script type="application/ld+json">${jsonld3}</script>-->`}
</svelte:head>
<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WXB3MNP"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->
<div class="main-container" use:watchResize={handleResize}>
    <div class="row align-items-center justify-content-start mx-0 d-flex d-lg-none mobile-panel">
        <button class="main-menu-toggle menu-toggle" aria-controls="main-menu" aria-expanded="true">
            <span class="menu-toggle menu-text" on:click={toggleMobileMenuVisibility}>MENU</span>
            <span class="menu-toggle-box" on:click={toggleMobileMenuVisibility}>
                <span class="menu-toggle-inner"></span>
            </span>
        </button>
    </div>
<!--    <div class="row top-panel align-items-center justify-content-center mx-0">-->
<!--        <div class="col-sm"></div>-->
<!--        <div class="row mx-0 pt-3 pb-3 header">-->
<!--                <div class="col-sm-12 col-lg-6 d-flex justify-content-center justify-content-lg-start company-name">Centrum Psychiatrii i Psychoterapii COLLIGO</div>-->
<!--                <div class="col-sm-12 col-lg-5 d-flex justify-content-center justify-content-lg-end p-0"><button class="btn-mydr-pp" on:click={openMyDr} data-appname="drw" data-evisit="false" data-token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmYWNpbGl0eV9pZCI6MTcwMDJ9.uT7wHuaDydaRO01jtypUdIVmdITQb28UYiVdp6tCS-Y"><i class="icon icon-display"></i>&nbsp;&nbsp;&nbsp;Rejestracja on-line</button></div>-->
<!--                <div class="col-sm-12 col-lg-1 d-flex justify-content-center justify-content-lg-end p-0"><i class="icon icon-phone"></i>&nbsp;&nbsp;Rejestracja<span><a href="tel:504646466" class="call-number">504 64 64 66</a></span></div>-->
<!--        </div>-->
<!--        <div class="col-sm"></div>-->
<!--    </div>-->
        <div class="row top-panel align-items-center justify-content-center mx-0" transition:fade="{{ duration: 100 }}">
            <div class="col-sm"></div>
            <div class="d-flex flex-lg-row flex-wrap align-items-center flex-column justify-content-sm-center justify-content-lg-between mx-0 pt-4 pb-4">
                <div class="flex-column flex-fill">
                    {#if !$currentCity || $currentCity === 'torun'}
                        <a href="/">
                            <img class='main-logo' src="/images/colligo-logo-poprawne.png" width="300" height="129" alt="Logotyp Centrum Psychiatrii i Psychoterapii COLLIGO" title="COLLIGO - Specjaliści z Psychiatrii, Psychoterapii, Psychologii i Seksuologii pomagający pacjentom w Toruniu i Bydgoszczy">
                        </a>
                    {:else if $currentCity === 'bydgoszcz'}
                        <a href="/bydgoszcz/">
                            <img class='main-logo' src="/images/colligo-logo-poprawne.png" width="300" height="129" alt="Logotyp Centrum Psychiatrii i Psychoterapii COLLIGO" title="COLLIGO - Specjaliści z Psychiatrii, Psychoterapii, Psychologii i Seksuologii pomagający pacjentom w Bydgoszczy">
                        </a>
                    {/if}
                </div>
                <div class="col-sm-12 col-lg-2 d-flex justify-content-center justify-content-lg-end p-0 mt-3 mt-lg-0">
                    <button class="btn-mydr-pp" on:click={openMyDr} data-appname="drw" data-evisit="false" data-token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmYWNpbGl0eV9pZCI6MTcwMDJ9.uT7wHuaDydaRO01jtypUdIVmdITQb28UYiVdp6tCS-Y"><i class="icon icon-display"></i>&nbsp;&nbsp;&nbsp;Rejestracja on-line</button>
                </div>
                <div class="col-sm-12 col-lg-5 d-flex align-items-center align-items-lg-end flex-column justify-content-center justify-content-lg-end p-0">
                    {#if !$currentCity || $currentCity === 'torun'}
                        <div class="d-flex justify-content-end align-items-center">
                            <i class="icon icon-phone"></i>&nbsp;&nbsp;Rejestracja Toruń<span><a href="tel:504646466" class="call-number">504 64 64 66</a></span>
                        </div>
                    {/if}
                    {#if !$currentCity || $currentCity === 'bydgoszcz'}
                        <div class="d-flex justify-content-end align-items-center">
                            <i class="icon icon-phone"></i>&nbsp;&nbsp;Rejestracja Bydgoszcz<span><a href="tel:798238449" class="call-number">798 238 449</a></span>
                        </div>
                    {/if}
                </div>
            </div>
            <div class="col-sm"></div>
        </div>
    {#if mobileMenuVisible}
        <div class="row menu-panel align-items-center justify-content-center mx-0">
            <div class="col-sm"></div>
            <div class="d-flex flex-row flex-wrap align-items-center justify-content-evenly mx-0">
                <div class="flex-column">
                    <div class="flex-row flex-wrap d-flex menu-items position-relative align-items-center">
                        <div class="flex-column main-menu-link"><a href={$url("/")} title="Strona główna" on:click={hideMobileMenu}>Strona główna</a></div>
                        <div class="flex-column menu-team">
                            <a href="javascript:void(null)" title="Zespół">Zespół</a>
                            <div class="city-selector">
                                <a href={$url("/torun/zespol/")} title="Zespół" on:click={hideMobileMenu}>Toruń</a>
                                <a href={$url("/bydgoszcz/zespol/")} title="Zespół" on:click={hideMobileMenu}>Bydgoszcz</a>
                                <a href={$url("/zespol/")} title="Zespół" on:click={hideMobileMenu}>Cały zespół</a>
                            </div>
                        </div>
                        <div class="flex-column menu-offerings">
                            <a href="javascript:void(null)" title="Oferta">Oferta</a>
                            <div class="city-selector">
                                <a href={$url("/torun/uslugi/")} title="Oferta" on:click={hideMobileMenu}>Toruń</a>
                                <a href={$url("/bydgoszcz/uslugi/")} title="Oferta" on:click={hideMobileMenu}>Bydgoszcz</a>
                                <a href={$url("/uslugi/")} title="Oferta" on:click={hideMobileMenu}>Pełna oferta</a>
                            </div>
                        </div>
                        <div class="flex-column menu-pricing">
                            <a href="javascript:void(null)" title="Cennik">Cennik</a>
                            <div class="city-selector">
                                <a href={$url("/torun/cennik/")} title="Cennik usług w Toruniu" on:click={hideMobileMenu}>Toruń</a>
                                <a href={$url("/bydgoszcz/cennik/")} title="Cennik usług w Bydgoszczy" on:click={hideMobileMenu}>Bydgoszcz</a>
                            </div>
                        </div>
                        <div class="flex-column"><a href={$url("/wspolpraca/")} title="Współpraca" on:click={hideMobileMenu}>Współpraca</a></div>
<!--                        <div class="flex-column"><a href={$url("/blog/")} title="Blog" on:click={hideMobileMenu}>Blog</a></div>-->
                        <div class="flex-column menu-visit">
                            <a href="javascript:void(null)" title="Wizyta">Wizyta</a>
                            <div class="city-selector">
                                <a href={$url("/wizyta/")} title="Wizyta" on:click={hideMobileMenu}>Ważne informacje</a>
                                <a href={$url("/do-pobrania/")} title="Do pobrania" on:click={hideMobileMenu}>Do pobrania</a>
                            </div>
                        </div>
                        <div class="flex-column"><a href={$url("/oferty-pracy/")} title="Oferty pracy" on:click={hideMobileMenu}>Oferty pracy</a></div>
                        <div class="flex-column mennu-contact">
                            <a href="javascript:void(null)" title="Kontakt">Kontakt</a>
                            <div class="city-selector">
                                <a href={$url("/torun/kontakt/")} title="Dane kontaktowe Colligo w Toruniu" on:click={hideMobileMenu}>Toruń</a>
                                <a href={$url("/bydgoszcz/kontakt/")} title="Dane kontaktowe Colligo w Bydgoszczy" on:click={hideMobileMenu}>Bydgoszcz</a>
                            </div>
                        </div>
                        <div class="flex-column menu-socials"><a href="https://facebook.com/colligotorun" title="Colligo na FB" target="_blank" on:click={hideMobileMenu}><i class="icon icon-facebook"></i></a></div>
                    </div>
                </div>
            </div>
            <div class="col-sm"></div>
        </div>
    {/if}

    <div class="row page-contents align-items-start justify-content-center mx-0">
        <slot/>
    </div>
    <div class="row mx-0">
        <div class="col-12 align-items-center justify-content-center mx-0">
            <ShareButtons/>
        </div>
    </div>
    <div class="footer {footerClass}">
        <div class="row mx-0">
            <div class="col-12 text-center pt-1 pt-md-3 pt-lg-5">
                {#if !$currentCity || $currentCity === 'torun'}
                    <p>Siedziba spółki: ul. Wschodnia 34, 87-100 Toruń</p>
                    <p>Rejestracja:<br><a href="/torun/" title="Oddział w Toruniu">Toruń</a> - 504 64 64 66<br><a href="/bydgoszcz/" title="Oddział w Bydgoszczy">Bydgoszcz</a> - 798 238 449</p>
                {/if}
                {#if $currentCity === 'bydgoszcz'}
                    <p>Adres placówki: ul. Jana Zamoyskiego 2, 85-063 Bydgoszcz</p>
                    <p>Rejestracja:<br><a href="/bydgoszcz/" title="Oddział w Bydgoszczy">Bydgoszcz</a> - 798 238 449</p>
                {/if}
                <p><a href="/regulamin/">Regulamin</a></p>
                <p><a href="/documents/Standardy_Ochrony_Maloletnich_Colligo.pdf" target="_blank">Standardy Ochrony Małoletnich</a></p>
                <p><a href="/documents/Standardy_Ochrony_Maloletnich_Colligo_wersja_skrocona.pdf" target="_blank">Standardy Ochrony Małoletnich - wersja dla Małoletnich</a></p>
                <p class="pt-5">
                    Psychiatria dzieci i młodzieży, psychiatria osób dorosłych, psychoterapia, psychologia | COLLIGO © 2023.
                </p>
            </div>
        </div>
        <div class="row mx-0 pb-5">
            <div class="col-12 col-md-2 offset-md-4">
                <p>Najczęściej oferowane usługi</p>
                <ul>
                    {#if !$currentCity || $currentCity === 'torun'}
                        <li>
                            <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Konsultacja
                                psychiatryczna w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychiatry.elder.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.elder.url.title, 'torun')}">Konsultacja
                            psychiatryczna osób starszych w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Konsultacja
                            psychiatryczna dzieci i młodzieży w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychology.consultation.url.address, 'torun'))}" title="{cityLocalizer($services.psychology.consultation.url.title, 'torun')}">Porady
                            psychologiczne w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychology.iq.url.address, 'torun'))}" title="{cityLocalizer($services.psychology.iq.url.title, 'torun')}">Badanie poziomu
                            intelektu w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychology.personality.url.address, 'torun'))}" title="{cityLocalizer($services.psychology.personality.url.title, 'torun')}">Badanie osobowości w
                            Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychology.cognitive.url.address, 'torun'))}" title="{cityLocalizer($services.psychology.cognitive.url.title, 'torun')}">Badanie
                            funkcji poznawczych w Toruniu</a></li>
                        <li>
                            <a href="{$url(cityLocalizer($services.psychoterapy.parents.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.parents.url.title, 'torun')}">Konsultacja
                                psychologiczna dzieci w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.children.url.title, 'torun')}">Psychoterapia
                            dzieci i młodzieży Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.family.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.family.url.title, 'torun')}">Psychoterapia
                            rodzinna Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.system.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.system.url.title, 'torun')}">Psychoterapia
                            systemowa Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.pair.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.pair.url.title, 'torun')}">Psychoterapia par w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychoterapy.adult.url.title, 'torun')}">Psychoterapia indywidualna w Toruniu</a></li>
                        <li><a href="{$url(cityLocalizer($services.group.socialSkills.url.address, 'torun'))}" title="{cityLocalizer($services.group.socialSkills.url.title, 'torun')}">Trening umiejętności społecznych w Toruniu</a></li>
<!--                        <li><a href="{$url(cityLocalizer($services.group.developmentGroup.url.address, 'torun'))}" title="{cityLocalizer($services.group.developmentGroup.url.title, 'torun')}">Grupa terapeutyczno-rozwojowa dla nastolatków w Toruniu</a></li>-->
<!--                        <li><a href="{$url(cityLocalizer($services.group.developmentGroupYoung.url.address, 'torun'))}" title="{cityLocalizer($services.group.developmentGroupYoung.url.title, 'torun')}">Grupa terapeutyczno-rozwojowa dla młodzieży w Toruniu</a></li>-->
<!--                        <li><a href="{$url(cityLocalizer($services.group.developmentGroupAdult.url.address, 'torun'))}" title="{cityLocalizer($services.group.developmentGroupAdult.url.title, 'torun')}">Grupa terapeutyczno-rozwojowa dla dorosłych Toruniu</a></li>-->
                    {/if}
                    {#if !$currentCity || $currentCity === 'bydgoszcz'}
                        <li><a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Konsultacja
                            psychiatryczna dzieci i młodzieży w Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychology.consultation.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychology.consultation.url.title, 'bydgoszcz')}">Porady
                            psychologiczne w Bydgoszczy</a></li>
                        <li>
                            <a href="{$url(cityLocalizer($services.psychoterapy.parents.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.parents.url.title, 'bydgoszcz')}">Konsultacja
                                psychologiczna dzieci w Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.children.url.title, 'bydgoszcz')}">Psychoterapia
                            dzieci i młodzieży Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.family.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.family.url.title, 'bydgoszcz')}">Psychoterapia
                            rodzinna Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.system.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.system.url.title, 'bydgoszcz')}">Psychoterapia
                            systemowa Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.pair.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.pair.url.title, 'bydgoszcz')}">Psychoterapia par w Bydgoszczy</a></li>
                        <li><a href="{$url(cityLocalizer($services.psychoterapy.adult.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychoterapy.adult.url.title, 'bydgoszcz')}">Psychoterapia indywidualna w Bydgoszczy</a></li>
                    {/if}
                </ul>
            </div>
            <div class="col-12 col-md-5 offset-md-1">
                <p>Najczęściej leczone choroby</p>
                <ul>
                    {#if !$currentCity || $currentCity === 'torun'}
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Depresja
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Nerwica
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Zaburzenia
                            lękowe w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Choroba
                            afektywna dwubiegunowa w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Psychoza
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zaburzenia
                            emocjonalne w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zaburzenia
                            osobowości w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zaburzenia
                            psychiczne w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Schizofrenia
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Bezsenność
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Otępienie
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Nerwica
                            natręctw w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zaburzenia
                            odżywiania w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zespół
                            stresu pourazowego w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'torun')}">Zaburzenia
                            psychosomatyczne w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Fobie
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Lęki
                            w Toruniu</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.adult.url.address, 'torun'))}" title="{cityLocalizer($services.psychiatry.adult.url.title, 'torun')}">Zaburzenia
                            zachowania w Toruniu</a></li>
                    {/if}
                    {#if !$currentCity || $currentCity === 'bydgoszcz'}
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zaburzenia
                            emocjonalne w Bydgoszczy</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zaburzenia
                            osobowości w Bydgoszczy</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zaburzenia
                            psychiczne w Bydgoszczy</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zaburzenia
                            odżywiania w Bydgoszczy</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zespół
                            stresu pourazowego w Bydgoszczy</a></li>
                    <li>
                        <a href="{$url(cityLocalizer($services.psychiatry.children.url.address, 'bydgoszcz'))}" title="{cityLocalizer($services.psychiatry.children.url.title, 'bydgoszcz')}">Zaburzenia
                            psychosomatyczne w Bydgoszczy</a></li>
                    {/if}
                </ul>
            </div>
        </div>
    </div>
</div>



<style type="text/scss">
  @import '../styles/vars';

  .main-container {
    .main-logo {
      width: 300px;
      height: 129px;
    }

    .page-contents {
      min-height: 500px;
    }
    .footer {
      color: $colligo-dark-gray;
      background-color: #181818;
      font-weight: 400;
      font-size: 12px;
      margin-top: 80px;

      &.hidden {
        display: none;
      }

      ul {
        padding: 0;
        margin: 0;
        list-style-type: none;

        li {
          margin: 0;
          padding: 0;
          line-height: 20px;
        }
      }

      a {
        color: $colligo-dark-gray;

        &:active {
          color: $colligo-dark-gray;
        }
      }
    }

    .top-panel {

      .header {
        .company-name {
          color: $colligo-green;
          font-weight: 400;
        }
        & > div {
          white-space: nowrap;
          display: flex;
          align-items: center;
          font-weight: 300;
        }
      }

      & > div {
        max-width: 1200px;
      }

      button {
        width: auto!important;
        height: auto!important;
        border: none!important;
        margin: auto!important;
        background-color: transparent;
        font-weight: 300;
        display: flex;
        align-items: center;
      }

      .call-number {
        font-size: 20px;
        font-weight: bold;
        color: $colligo-green;
        padding-left: 10px;
      }

      @media (max-width: 996px) {
        .call-number {
          display: block;
          padding: 2px 0 2px 12px;
        }

        margin-top: 60px;
      }
    }

    .menu-panel {
      padding-top: 30px;
      padding-bottom: 30px;
      background-color: #f7f7f7;

      .main-menu-link {
        display: none;
      }

      @media (max-width: 996px) {
        .main-logo {
          display: none;
        }

        .main-menu-link {
          display: block!important;
        }

        .col-sm {
          display: none;
        }

        align-items: flex-start!important;
        position: fixed;
        top: 36px;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        z-index: 1;
        opacity: 0.97;

        .flex-column {
          flex: 1;
          width: 100%!important;
        }

        .flex-row {
          justify-content: flex-start!important;
          flex-direction: column!important;
        }

        a {
          margin-top: 10px;
          margin-bottom: 10px;
          display: block;
        }

        .menu-items {
          & > div {
            padding-left: 10px!important;
            text-align: center;

            a {
              font-size: 1.1rem;
            }
          }
        }
      }

      .menu-items {
        & > div {
          padding-left: 50px;

          a {
            font-size: 1.1rem;
          }
        }
      }

      & > div {
        max-width: 1200px;
      }

      a {

      }
    }
  }

  .mobile-panel {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    visibility: visible;
    position: fixed;
    z-index: 998;
    top: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    border-bottom: 1px solid #a9c4c26b;
    padding: 10px 20px 10px 10px;
    height: 60px;
    -webkit-box-shadow: 0 2px 6px #88888842;
    box-shadow: 0 2px 6px #88888842;

    .main-menu-toggle {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    button {
      outline-color: transparent!important;
    }

    .menu-toggle {
      color: #73bfa6;
      padding: 10px 10px;
      cursor: pointer;
      -webkit-transition-property: opacity;
      -o-transition-property: opacity;
      transition-property: opacity;
      -webkit-transition-duration: 0.15s;
      -o-transition-duration: 0.15s;
      transition-duration: 0.15s;
      -webkit-transition-timing-function: linear;
      -o-transition-timing-function: linear;
      transition-timing-function: linear;
      font: inherit;
      text-transform: none;
      background: none;
      border: 0;
      margin: 0;
      overflow: visible;

      &.menu-text {
        margin-right: 4px;
        font-size: 10px;
        letter-spacing: 3px;
        padding: 0 !important;
        display: block;
      }

      .menu-toggle-box {
        width: 22px;
        height: 16px;
        display: block;
        position: relative;

        .menu-toggle-inner, .menu-toggle-inner:after, .menu-toggle-inner:before {
          background-color: #73bfa6;
          display: block;
          top: 50%;
          margin-top: -1px;
          width: 22px;
          height: 2px;
          border-radius: 0px;
          position: absolute;
          -webkit-transition-duration: 0.1s;
          -o-transition-duration: 0.1s;
          transition-duration: 0.1s;
          -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
          -o-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }

        .menu-toggle-inner:after {
          top: -6px!important;
          content: " ";
        }

        .menu-toggle-inner:before {
          bottom: -7px!important;
          content: " ";
          top: initial;
        }
      }
    }
  }

  .city-selector {
    position: absolute;
    top: 25px;
    display: none;
    flex-direction: column;
    background-color: #f7f7f7;
    padding: 6px 30px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0 6px 8px #88888842;
    margin-left: -29px;

    @media (max-width: 991px) {
      position: relative;
      top: 0;
      margin-left: 0;
      box-shadow: none;
      background-color: transparent;
      padding: 0 12px;

      a {
        margin-top: 0!important;
        margin-bottom: 0!important;
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
    }

    a {
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 15px !important;
    }
  }

  .menu-team,
  .menu-pricing,
  .menu-offerings,
  .menu-visit,
  .mennu-contact {
    &:hover {
      .city-selector {
        display: flex;
      }
    }
  }

  .menu-socials {
    :global(a) {
      font-size: 0 !important;
    }
  }
</style>


